import NavigationService from "../../services/vue/components/NavigationService";
import store from '../index';
import CustomEvents from "../../services/CustomEvents";
import ProgressBarService from "../../services/vue/components/ProgressBarService";
import Amplitude from '../../plugins/Amplitude';

export default {
  namespaced: true,

  state: {
    currentView: 'GeneralInfoView',
  },

  getters: {
    getCurrentView: (state) => {
      return state.currentView;
    },
  },

  mutations: {
    nextView: (state) => {
      const gender = store.getters['userSelections/getGender'];
      const step = ProgressBarService.getStep(state.currentView);
      const view = state.currentView;

      state.currentView = NavigationService.getNextViewName(state.currentView, gender);

      CustomEvents.trigger('wizardStepWasChanged', view, step);
      Amplitude.logEvent('next step', {view, step});
    },

    prevView: (state) => {
      const gender = store.getters['userSelections/getGender'];
      const step = ProgressBarService.getStep(state.currentView);
      const view = state.currentView;

      state.currentView = NavigationService.getPreviousViewName(view, gender);

      CustomEvents.trigger('wizardStepWasChanged', view, step);
      Amplitude.logEvent('previous step', {view, step});
    },

    startAgain: (state) => {
      state.currentView = NavigationService.getFirstView();

      CustomEvents.trigger('wizardStepWasChanged', state.currentView, 1);
      Amplitude.logEvent('start again', {view: state.currentView, step: 1});
    },

    reset: (state) => {
      state.currentView = NavigationService.getFirstView();
    },
  },
};
